module.exports = __webpack_public_path__ + "static/media/1.862a49c5.svg";